import {
  CLEAR_CHAT_SESSION,
  SET_CALLOUT,
  SET_CHAT_VIEW,
  SET_CONVERSATION_PAGINATION,
  SET_IS_CHAT_OPEN,
  SET_LAST_CHAT_CONVERSATION_ID,
  SET_LIVE_CONTEXT,
  SET_MESSAGE_SENT,
  SET_MESSAGES,
  SET_SELECTED_CONVERSATION,
  UPDATE_MESSAGE_BY_ID,
} from "./types";

export const setIsChatOpen = isOpen => ({
  type: SET_IS_CHAT_OPEN,
  payload: isOpen,
});

export const setChatView = view => ({
  type: SET_CHAT_VIEW,
  payload: view,
});

export const setSelectedConversation = conversation => ({
  type: SET_SELECTED_CONVERSATION,
  payload: conversation,
});

export const setConversationPagination = pagination => ({
  type: SET_CONVERSATION_PAGINATION,
  payload: pagination,
});

export const setMessages = messagesOrUpdater => ({
  type: SET_MESSAGES,
  payload: messagesOrUpdater,
});

export const updateMessageById = (id, updater) => ({
  type: UPDATE_MESSAGE_BY_ID,
  payload: { id, updater },
});

export const setLiveContext = context => ({
  type: SET_LIVE_CONTEXT,
  payload: context,
});

export const clearChatSession = () => ({
  type: CLEAR_CHAT_SESSION,
});

export const setMessageSent = isSent => ({
  type: SET_MESSAGE_SENT,
  payload: isSent,
});

export const setCallout = callout => ({
  type: SET_CALLOUT,
  payload: callout,
});

export const setLastChatConversationId = id => ({
  type: SET_LAST_CHAT_CONVERSATION_ID,
  payload: id,
});
